import CustomerDisplay from './CustomerDisplay'

export default CustomerDisplay
